import {EmbeddedListView} from "./EmbeddedListView";
import * as trans from "../../common/Translator";
import * as DomainBaseFieldIDs from "../../constants/DomainBaseFieldIDs";
import * as FieldType from "../../constants/FieldType";
import * as DomainBaseEntities from "../../constants/DomainBaseEntities";
import {newLine} from "./EditScreenGroup";
import {ajaxJSON} from "../../common/NamaCommon";
import * as urls from "../../constants/NamaURLS";
import {QuestionFieldsEditor} from "../../widgets/QuestionFieldsEditor";
import {findQuestionFieldVal, findQuestionObjFieldVal} from "../Navbar";
import {currentLoginInfo} from "../../login/LoginPresenter";
import * as notifier from "../../common/ErrorsNotification";
import {isInNewMode} from "./EditScreenToolbar";
import {BaseWidget} from "../../widgets/BaseWidget";
import * as EditScreenListLinkType from "../../constants/EditScreenListLinkType";

export class DiscussionRecordWidget extends BaseWidget {
    constructor(block, presenter, groups) {
        super({
            id: "discussions",
            owner: presenter,
            block: block,
            editPresenter: presenter
        });
        let that = this;
        that.block = block;
        that.presenter = presenter;
        that.groups = groups;
    }
    setEnabled(enabled) {

    }
    render() {
        let that = this;
        let presenter = that.presenter;
        let block = that.block;
        block.linkType = EditScreenListLinkType.QuestionField;
        block.linkFieldId = "id";
        that.embeddedListView = new EmbeddedListView({
            id: "discussionsListViewId",
            owner: that,
            block: block,
            editPresenter: presenter
        }, "discussionsListViewId", DomainBaseEntities.DocumentBook);
        that.groups.append(that.embeddedListView.createElement());
        let element = $(`
        <li class="k-active discussion">
            <span>${trans.translateId("discussion")}</span>
            <div class="widgetsList discussionsRecordContainer"/>
        </li>`);
        that.discussionsRecordContainer = element.find(".discussionsRecordContainer");
        that.addDataWidget = (widget) => {
            that.discussionsRecordContainer.append(widget)
        };
        that.rootElement = () => {
            return that.discussionsRecordContainer;
        };
        that.content = that.discussionsRecordContainer;
        let okBtn = $(`<button style="margin: 1px" id = "okBtn">${trans.translateId("ok")}</button>`);
        let noBtn = $(`<button style="margin: 1px" id = "noBtn">${trans.translateId("no")}</button>`);
        okBtn.kendoButton({
            click: (e) => {
                let filledQuestions = that.questionFieldsEditor.getQuestionFields();
                let req = {
                    owner: presenter.record,
                    discussion: findQuestionFieldVal(filledQuestions, DomainBaseFieldIDs.DiscussionRecord_discussion),
                    user: currentLoginInfo().userInfo,
                    ref1: findQuestionObjFieldVal(filledQuestions, DomainBaseFieldIDs.DiscussionRecord_ref1),
                    ref2: findQuestionObjFieldVal(filledQuestions, DomainBaseFieldIDs.DiscussionRecord_ref2),
                    attachment1: {attachmentInfo: findQuestionObjFieldVal(filledQuestions, DomainBaseFieldIDs.DiscussionRecord_attachment1)},
                    attachment2: {attachmentInfo: findQuestionObjFieldVal(filledQuestions, DomainBaseFieldIDs.DiscussionRecord_attachment2)},
                    attachment3: {attachmentInfo: findQuestionObjFieldVal(filledQuestions, DomainBaseFieldIDs.DiscussionRecord_attachment3)},
                    attachment4: {attachmentInfo: findQuestionObjFieldVal(filledQuestions, DomainBaseFieldIDs.DiscussionRecord_attachment4)},
                };
                ajaxJSON(urls.AddDiscussion, {request: JSON.stringify(req)}, (result) => {
                        notifier.showSuccess(trans.translateId("recordSavedCorrectly"));
                        filledQuestions.forEach(q => that.questionFieldsEditor.valueWidgets[q.id].setValueInElement(null));
                        that.setValue();
                    }
                );
            }
        });
        noBtn.kendoButton({
            click: (e) => {

            }
        });
        that.discussionsRecordContainer.append(newLine());
        let buttons = $(`<div style=" margin: 20px;float: left"></div>`);
        buttons.append(okBtn);
        buttons.append(noBtn);
        that.discussionsRecordContainer.append(buttons);
        that.discussionsRecordContainer.append(newLine());
        that.groups.append(element);
    }

    prepareDiscussionQuestions() {
        let questionFields = [];
        questionFields.push({
            id: DomainBaseFieldIDs.DiscussionRecord_discussion,
            metaData: {
                id: DomainBaseFieldIDs.DiscussionRecord_discussion,
                fieldType: FieldType.BigText
            }
        });
        questionFields.push({
            id: DomainBaseFieldIDs.DiscussionRecord_attachment1,
            metaData: {
                id: DomainBaseFieldIDs.DiscussionRecord_attachment1,
                fieldType: FieldType.Binary
            }
        });
        questionFields.push({
            id: DomainBaseFieldIDs.DiscussionRecord_attachment2,
            metaData: {
                id: DomainBaseFieldIDs.DiscussionRecord_attachment2,
                fieldType: FieldType.Binary
            }
        });
        questionFields.push({
            id: DomainBaseFieldIDs.DiscussionRecord_attachment3,
            metaData: {
                id: DomainBaseFieldIDs.DiscussionRecord_attachment3,
                fieldType: FieldType.Binary
            }
        });
        questionFields.push({
            id: DomainBaseFieldIDs.DiscussionRecord_attachment4,
            metaData: {
                id: DomainBaseFieldIDs.DiscussionRecord_attachment4,
                fieldType: FieldType.Binary
            }
        });
        questionFields.push({
            id: DomainBaseFieldIDs.DiscussionRecord_ref1,
            metaData: {
                id: DomainBaseFieldIDs.DiscussionRecord_ref1,
                fieldType: FieldType.Genericreference
            }
        });
        questionFields.push({
            id: DomainBaseFieldIDs.DiscussionRecord_ref2,
            metaData: {
                id: DomainBaseFieldIDs.DiscussionRecord_ref2,
                fieldType: FieldType.Genericreference
            }
        });
        return questionFields;
    }

    preValidate() {
        let that = this;
        let groups = that.groups;
        if (isInNewMode(that.presenter)) {
            groups.find(".discussion").css('display', 'none');
            groups.find(".discussionsListViewId").css('display', 'none');
        } else {
            groups.find(".discussion").css('display', '');
            groups.find(".discussionsListViewId").css('display', '');
        }
    }

    afterAttach() {
        let that = this;
        that.rootElement = () => {
            return that.groups;
        };
        let questionFields = that.prepareDiscussionQuestions();
        that.questionFieldsEditor = new QuestionFieldsEditor(that.presenter.entityType);
        that.questionFieldsEditor.edit(questionFields, null, null, null, that.presenter, that, that.presenter);
        that.embeddedListView.afterAttach();
        that.preValidate();
    }

    setValue() {
        this.embeddedListView.setValue();
    }
}